import { Box, Stack, Typography } from '@mui/material';
import { BackButton } from '../../../components/common/Button/BackButton/BackButton';
import { isReactNative } from '../../../common/utils/reactNativeHelpers';

export const TermsOfUsage = () => {
  return (
    <Stack
      sx={{
        gap: { xs: '16px' },
        padding: '20px',
        marginTop: '60px',
        overflowY: 'scroll',
      }}
    >
      {isReactNative ? <BackButton /> : null}
      <Typography variant="h1" color="common.white" textAlign="center">
        КОРИСТУВАЦЬКА УГОДА
      </Typography>
      <Typography variant="h2" color="common.white" textAlign="center">
        додатку для електрозаправок
      </Typography>
      <br />
      <Typography variant="body1" color="common.white">
        Останнє оновлення: <strong>06.03.2025</strong>
      </Typography>
      <br />
      <Typography variant="body1" color="common.white">
        Ця Користувацька угода (далі – «Угода») регулює використання мобільного
        додатку Electric Group (далі – «Додаток») та визначає умови надання
        доступу до послуг зарядних станцій для електромобілів. <br />
        Користуючись Додатком, ви підтверджуєте, що ознайомилися з умовами цієї
        Угоди, розумієте їх і погоджуєтесь їх дотримуватися.
      </Typography>
      <Typography variant="h6" color="common.white" gutterBottom>
        1. Реєстрація та доступ до Додатку
      </Typography>
      <Typography component="p" color="common.white">
        1.1. Для використання Додатку необхідно пройти реєстрацію, надавши
        актуальну контактну інформацію.
      </Typography>
      <Typography component="p" color="common.white">
        1.2. Ви несете відповідальність за збереження конфіденційності ваших
        облікових даних.
      </Typography>
      <Typography variant="h6" gutterBottom color="common.white">
        2. Використання персональних даних
      </Typography>
      <Typography component="p" color="common.white">
        2.1. Реєструючись у Додатку, ви даєте згоду на обробку ваших
        персональних даних відповідно до Політики конфіденційності.
      </Typography>
      <Typography component="p" color="common.white">
        2.2. Ми можемо збирати наступні дані:
      </Typography>
      <Box style={{ marginLeft: 20 }} color="common.white">
        - Ім'я, номер телефону, електронну пошту;
        <br />
        - Дані про платежі (у разі здійснення оплат через Додаток);
        <br />
        - Геолокацію вашого пристрою для відображення найближчих зарядних
        станцій;
        <br />- Дані про зарядні сесії (дата, час, обсяг спожитої енергії).
      </Box>
      <Typography component="p" color="common.white">
        2.3. Ваші дані використовуються виключно для надання послуг і покращення
        роботи Додатку.
      </Typography>
      <Typography variant="h6" gutterBottom color="common.white">
        3. Використання даних пристрою
      </Typography>
      <Typography component="p" color="common.white">
        3.1. Для коректної роботи Додаток може запитувати доступ до:
      </Typography>
      <Box style={{ marginLeft: 20 }} color="common.white">
        - <strong>Геолокації</strong> – для пошуку найближчих зарядних станцій;
        <br />- <strong>Камери</strong> – для сканування QR-коду зарядної
        станції;
        <br />- <strong>Даних про стан мережі</strong> – для перевірки
        доступності сервісу.
      </Box>
      <Typography component="p" color="common.white">
        3.2. Ви можете змінити налаштування доступу у своєму пристрої. Відмова у
        наданні доступу до певних функцій може обмежити роботу Додатку.
      </Typography>
      <Typography variant="h6" gutterBottom color="common.white">
        4. Порядок користування зарядними станціями
      </Typography>
      <Typography component="p" color="common.white">
        4.1. Для початку зарядної сесії необхідно:
      </Typography>
      <Box style={{ marginLeft: 20 }} color="common.white">
        - Відсканувати QR-код станції через Додаток;
        <br />
        - Вибрати тариф або метод оплати (за наявності платних послуг);
        <br />- Підтвердити початок зарядки.
      </Box>
      <Typography component="p" color="common.white">
        4.2. Ви зобов'язані дотримуватися інструкцій щодо користування зарядною
        станцією.
      </Typography>
      <Typography component="p" color="common.white">
        4.3. У разі несправності станції повідомте службу підтримки через
        Додаток.
      </Typography>
      <Typography variant="h6" gutterBottom color="common.white">
        5. Відповідальність Користувача
      </Typography>
      <Typography component="p" color="common.white">
        5.1. Користувач несе відповідальність за:
      </Typography>
      <Box style={{ marginLeft: 20 }} color="common.white">
        - Дотримання правил дорожнього руху та норм безпеки;
        <br />
        - Дотримання правил дорожнього руху та норм безпеки;
        <br />- Достовірність наданих персональних даних.
      </Box>
      <Typography component="p" color="common.white">
        5.2. У разі порушення правил доступ до Додатку може бути тимчасово або
        постійно заблокований
      </Typography>
      <Typography variant="h6" gutterBottom color="common.white">
        6. Відмова від відповідальності
      </Typography>
      <Typography component="p" color="common.white">
        6.1. Оператор Додатку не несе відповідальності за:
      </Typography>
      <Box style={{ marginLeft: 20 }} color="common.white">
        - Перебої у роботі зарядних станцій, викликані технічними несправностями
        або форс-мажорними обставинами;
        <br />
        - Витрати на електроенергію або інші платежі, здійснені через сторонні
        платіжні сервіси;
        <br />- Наслідки неправомірного використання Додатку третіми особами.
      </Box>
      <Typography variant="h6" gutterBottom color="common.white">
        7. Прикінцеві положення
      </Typography>
      <Typography component="p" color="common.white">
        7.1. Оператор залишає за собою право змінювати умови цієї Угоди.
      </Typography>
      <Typography component="p" color="common.white">
        7.2. Продовження використання Додатку після оновлення Угоди означає вашу
        згоду з її новими умовами.
      </Typography>
      <Typography component="p" color="common.white">
        7.3. У разі виникнення питань або суперечок, звертайтеся до служби
        підтримки через Додаток або за електронною адресою [email].
      </Typography>
      <Typography
        variant="body1"
        component="p"
        sx={{ mt: 3, fontWeight: 'bold' }}
        color="common.white"
      >
        Натискаючи кнопку «Прийняти», ви погоджуєтеся з умовами цієї Угоди.
      </Typography>
    </Stack>
  );
};
